import { MifeParcel } from '@/components/MifeParcel';
import { isTenant } from '@repo/utils';
import { createFileRoute } from '@tanstack/react-router';

// TODO: This type should come from the API schema
type Pfidac = {
  show_equity_hub: boolean;
};

export function canAccessInvestorHub(pfidac?: Pfidac) {
  return isTenant('pfida') && (pfidac?.show_equity_hub ?? false);
}

export const Route = createFileRoute('/_authenticated/_pfida/investor-hub')({
  component: () => <MifeParcel />,
});
